import { Event } from "event-system";
import { FederatedPointerEvent, Sprite, Texture } from "pixi.js";
import { UIButtonBase } from "./UIButtonBase";

export class Toggle extends UIButtonBase {
    public readonly onChange: Event<boolean>;
    public readonly icon: Sprite;

    private toggleValue: boolean;

    public get value(): boolean {
        return this.toggleValue;
    }

    public set value(value: boolean) {
        if (this.toggleValue == value) {
            return;
        }
        this.toggleValue = value;
        this.icon.texture = value ? this.onIcon : this.offIcon;
        this.onChange.emit(value);
    }

    public constructor(
        background: Texture,
        private readonly onIcon: Texture,
        private readonly offIcon: Texture,
        value: boolean
    ) {
        super({ defaultTexture: background });
        this.onChange = new Event();
        this.icon = new Sprite(value ? this.onIcon : this.offIcon);
        this.defaultView.addChild(this.icon);
        this.toggleValue = value;
    }

    public toggle(): void {
        this.value = !this.value;
    }

    protected override handlePointerUp(e: FederatedPointerEvent): void {
        this.toggle();
        super.handlePointerUp(e);
    }
} 